export const messages = {
  deleted: {
    id: "messages.chat-item.deleted",
    defaultMessage: "The message has been deleted",
  },
};
